import { SellerSummaryEnrollmentStatus } from './seller-summary-enrollment-status';
import { Pagination } from '@lsq-frontend/angular-shared/api-service';
import { ProtoListRequest } from '@lsq-frontend/angular-shared/api-service';

export class ListSellerSummaryRequest extends ProtoListRequest {
    public buyerKey: string;
    public excludeZeroEarlyPay: boolean;
    public sellerNameFilter: string;
    public sellerEnrollmentStatusFilter: SellerSummaryEnrollmentStatus[];
    public pagination: Pagination;
    public buyerPaidEarlyPaymentFeePercentageVisible: boolean;
    public forCurrentWeek: boolean;
    constructor(obj?: {
       buyerKey?: string;
       excludeZeroEarlyPay?: boolean;
       sellerNameFilter?: string;
       sellerEnrollmentStatusFilter?: SellerSummaryEnrollmentStatus[];
       pagination?: Pagination;
       buyerPaidEarlyPaymentFeePercentageVisible?: boolean;
       forCurrentWeek?: boolean;
    }) {
        super();
        if (obj != null) {
            this.buyerKey = typeof obj.buyerKey === 'undefined' ? this.buyerKey : obj.buyerKey;
            this.excludeZeroEarlyPay = typeof obj.excludeZeroEarlyPay === 'undefined' ? this.excludeZeroEarlyPay : obj.excludeZeroEarlyPay;
            this.sellerNameFilter = typeof obj.sellerNameFilter === 'undefined' ? this.sellerNameFilter : obj.sellerNameFilter;
            this.sellerEnrollmentStatusFilter = typeof obj.sellerEnrollmentStatusFilter === 'undefined' ? this.sellerEnrollmentStatusFilter : obj.sellerEnrollmentStatusFilter;
            this.pagination = typeof obj.pagination === 'undefined' ? this.pagination : obj.pagination;
            this.buyerPaidEarlyPaymentFeePercentageVisible = typeof obj.buyerPaidEarlyPaymentFeePercentageVisible === 'undefined' ? this.buyerPaidEarlyPaymentFeePercentageVisible : obj.buyerPaidEarlyPaymentFeePercentageVisible;
            this.forCurrentWeek = typeof obj.forCurrentWeek === 'undefined' ? this.forCurrentWeek : obj.forCurrentWeek;
        }
    }
}
